export interface Department {
  id: number;
  name: string;
  level: number;
  ParentId: number;
  jpId: string;
  plannerIds: string[];
  bussinesses: string[];
  totalUs: number;
  quantity: number;
  createdAt: Date;
  updatedAt: Date;
}

export function createMockDepartment(): Department {
  return {
    id: 1,
    name: 'Mock_Department',
    level: 1,
    jpId: '200200202',
    plannerIds: [],
    bussinesses: [],
    ParentId: null,
    totalUs: 0,
    quantity: 0,
    createdAt: new Date(),
    updatedAt: new Date()
  };
}

export const getAncestorsIndex = (
  department: Department,
  entities: { [id: number]: Department },
  name: string
) => {
  if (department.ParentId) {
    return getAncestorsIndex(
      entities[department.ParentId],
      entities,
      `-${department.name}${name}`
    );
  } else {
    return `${department.name}${name}`;
  }
};

export const getAncestorsIndexUpToLevel = (
  department: Department,
  entities: { [id: number]: Department },
  name: string,
  level: number
) => {
  if (department.level > level) {
    return getAncestorsIndexUpToLevel(
      entities[department.ParentId],
      entities,
      `-${department.name}${name}`,
      level
    );
  } else {
    return `${department.name}${name}`;
  }
};

export const getAvailableChildren = (
  plannerId: string,
  current: Department[],
  all: Department[],
  result: Department[]
) => {
  const available = all.filter(
    item =>
      item.plannerIds.includes(plannerId) &&
      current.map(i => i.id).includes(item.ParentId)
  );
  if (!available.length) {
    return result;
  } else {
    return getAvailableChildren(plannerId, available, all, [
      ...result,
      ...available
    ]);
  }
};

export const getAncestorsIndexUpToParentId = (
  department: Department,
  entities: { [id: number]: Department },
  name: string,
  id: number
) => {
  if (department.ParentId !== id) {
    return getAncestorsIndexUpToParentId(
      entities[department.ParentId],
      entities,
      `-${department.name}${name}`,
      id
    );
  } else {
    return `${department.name}${name}`;
  }
};
